import React from "react";
import "../Style/VisitUs.css";
import { Link } from "react-router-dom";
import {
  FaCoffee,
  FaMapMarkerAlt,
  FaClock,
  FaArrowLeft,
  FaInstagram,
} from "react-icons/fa";

function VisitUs() {
  return (
    <div className="visit-container">
      <div className="visit-card">
        <h2 className="visit-title">
          <FaCoffee style={{ marginRight: "10px", marginBottom: "-4px" }} />
          Visit Us
        </h2>

        <p className="visit-line">
          <FaMapMarkerAlt className="visit-icon" /> النبطية – حي الجامعات
        </p>

        <p className="visit-line">
          <FaClock className="visit-icon" /> Every day 8 AM – 11 PM
        </p>

        {/* 🌸 Instagram Button */}
        <div className="visit-social">
          <a
            href="https://www.instagram.com/blue.coffeeshop?igsh=MXd3MXRxbHBraTZ1eQ%3D%3D&utm_source=qr"
            target="_blank"
            rel="noopener noreferrer"
            className="insta-btn"
          >
            <FaInstagram className="insta-icon" />
          </a>
          <p className="insta-text">@blue.coffeeshop</p>
        </div>

        <Link to="/" className="back-btn">
          <FaArrowLeft style={{ marginRight: "8px" }} />
          Back to Home
        </Link>
      </div>
    </div>
  );
}

export default VisitUs;

